export var ProductProcessorsEnum;
(function (ProductProcessorsEnum) {
    ProductProcessorsEnum["ATTR_VALUE_PARSER"] = "attr_value_parser";
    ProductProcessorsEnum["AUTOPICK"] = "autopick";
    ProductProcessorsEnum["SIZE"] = "size";
    ProductProcessorsEnum["DELIVERY_SHEET_SIZES"] = "delivery_sheet_sizes";
    ProductProcessorsEnum["DELIVERY_ROLL"] = "delivery_roll";
    ProductProcessorsEnum["OUT_OF_STOCK"] = "out_of_stock";
})(ProductProcessorsEnum || (ProductProcessorsEnum = {}));
